import './App.css';
import React, { useState, useEffect } from 'react'
import { getDatabase, ref, set, onValue } from 'firebase/database'
import { BrowserRouter, Route, Routes } from 'react-router-dom'
import Home from './view/Home';
import Admin from './view/Admin';
import Texting from './view/Texting';

function App({ storage }) {
  const [info, setInfo] = useState(null)

  const getInfo = () => {
    const db = getDatabase()
    const jobInfo = ref(db, `/job`)

    onValue(jobInfo, (snapshot) => {
      const data = snapshot.val()

      if (data) {
        let jobData = []
        Object.entries(data).forEach(([key, value]) => {
          jobData.push([key, value])
        });

        if (jobData) {
          setInfo(jobData)
        }
      }
    })
  }

  useEffect(() => {
    getInfo()
  }, [])

  return (
    <div>
      <BrowserRouter>
        <Routes>
          <Route exact path={'/'} element={<Home info={info} storage={storage} />} />
          <Route exact path={'/admin0954'} element={<Admin info={info} storage={storage} />} />
          <Route exact path={'/texting'} element={<Texting />} />
        </Routes>
      </BrowserRouter>
    </div>
  );
}

export default App;
